const module = {
  namespaced: true,
  state: {
    name: "",
    petName: "",
    reminder: "",
    appointmentTime: "", 
    doctor: ""
  },
  mutations: {
    setVal(state, params) {
      state[params.key] = params.val
    },
    reset(state) {
      state.name = "";
      state.petName = "";
      state.reminder = "";
      state.appointmentTime = "";
      state.doctor = "";
    }
  },
  getters: {
    getInfo(state) {
      return {
        ...state
      }
    }
  },
};

export default module;
